import axios from 'axios';
import { apiUrl, tokenRequest } from '../authConfig';
import { AuthenticationResult, AccountInfo } from '@azure/msal-browser';
import { msalInstance } from '../service/msal';

const apiClient = axios.create({
  baseURL: apiUrl,
});

apiClient.interceptors.request.use(
  async (config) => {
    const account: AccountInfo | null = msalInstance.getActiveAccount();
    if (account) {
      try {
        const response: AuthenticationResult = await msalInstance.acquireTokenSilent({
          ...tokenRequest,
          account,
        });
        const accessToken = response.accessToken;
        config.headers['Authorization'] = `Bearer ${accessToken}`;
      } catch (error) {
        console.error('Failed to acquire token silently', error);
      }
    }
    return config;
  },
  (error) => {
    return msalInstance.acquireTokenRedirect(tokenRequest);
    //Promise.reject(error);
  }
);

export default apiClient;
